module.exports = __webpack_public_path__ + "img/icon-service-radius-over.8f43442b.svg";